/**
 * Blank values: null, undefined, "" or any string with only white spaces
 */
// eslint-disable-next-line import/prefer-default-export
export function isBlank(value: unknown): value is null | undefined {
  if (value === 0) return false;
  if (value === false) return false;
  if (value?.toString()?.trim()) return false;

  return true;
}

export function isNumber(value: unknown) {
  if (isBlank(value)) return false;
  return Number.isFinite(+value);
}

const IP_REGEX =
  /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;

export function isValidIpAddress(value: string) {
  if (isBlank(value)) return false;
  return IP_REGEX.test(value);
}

/**
 * A single IPv4 address or an IPv4 range in CIDR notation (prefix 0-32)
 */
export function isValidIpv4OrCidr(value: string) {
  if (isBlank(value)) return false;
  const [address, prefix, ...rest] = value.split("/");
  if (rest.length || !IP_REGEX.test(address)) return false;
  return prefix === undefined || /^(3[0-2]|[12]?\d)$/.test(prefix);
}

const HOSTNAME_REGEX =
  /^(?:\*(?:\.)?)?(?!-)[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.(?!-)[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/;

export function isValidHostname(value: string) {
  if (isBlank(value)) return false;
  return HOSTNAME_REGEX.test(value);
}

const JSON_OBJ_REGEX =
  /^\s*\{\s*("[\w\s]*"\s*:\s*("[^"]*"|\d+|true|false|null)\s*,?\s*)*\}\s*$/;

export function isJSONObject(str: string): boolean {
  if (isBlank(str)) return false;

  if (JSON_OBJ_REGEX.test(str)) return true;

  return false;
}
